import React, { useEffect, useState, useRef } from "react";

import { AiOutlineClose } from "react-icons/ai";
import Select from "react-dropdown-select";
import SelectWithCheckmark from "../components/SelectWithCheckmark";

import axiosInstance from "../services/axiosInstance";

const EditDetailPopup = ({
  userList,
  getUserList,
  user,
  setUser,
  openPopUp,
  closePopUp,
}) => {
  const [userRoles, setUserRoles] = useState([]);
  const [userModulePermissions, setUserModulePermissions] = useState([]);
  const [errors, setErrors] = useState({});
  const hasSetPermissions = useRef(false);

  useEffect(() => {
    if (!hasSetPermissions.current && user?.userModulePermissions) {
      setUserModulePermissions(JSON.parse(user.userModulePermissions));
      hasSetPermissions.current = true;
    }
  }, [user]);

  useEffect(() => {
    getUserRoles();
    if (user?.userModulePermissions && !hasSetPermissions.current) {
      setUserModulePermissions(JSON.parse(user.userModulePermissions));
      hasSetPermissions.current = true;
    }
  }, []);

  const closeEditUserPopup = () => {
    setUserModulePermissions([]);
    setErrors({});
    hasSetPermissions.current = false;
  };

  const userRoleOptions = userRoles.map((role) => ({
    roleId: role.roleId,
    roleName: role.roleName,
  }));

  const getUserRoles = async () => {
    const response = await axiosInstance.get(
      "/api/UserManagement/getAllUserRoles"
    );

    setUserRoles(response);
  };

  const mapUserData = () => {
    const userModulePermissionJSON = userModulePermissions.map((module) => ({
      applicationModuleId: module.applicationModuleId,
    }));

    const clonedUser = JSON.parse(JSON.stringify(user));
    clonedUser.userModulePermissions = JSON.stringify(userModulePermissionJSON);

    return clonedUser;
  };

  const validateForm = () => {
    let newErrors = {};
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    var isEmailExist =
      userList.filter(
        (x) => x.userEmail === user.userEmail?.trim() && x.userId != user.userId
      ) || [];
    var isUIDExist =
      userList.filter(
        (x) => x.uid === user.uid?.trim() && x.userId != user.userId
      ) || [];

    if (!user.userFirstName.trim())
      newErrors.userFirstName = "First Name is required.";
    if (!user.userLastName.trim())
      newErrors.userLastName = "Last Name is required.";
    if (!user.uid.trim()) {
      newErrors.uid = "User ID is required.";
    } else if (user.uid.trim().length !== 3) {
      newErrors.uid = "User ID must be exactly 3 characters.";
    }
    if (isUIDExist.length >= 1) newErrors.uid = "UID already exist.";
    if (!user.roleId) newErrors.roleId = "Role selection is required.";
    if (!user.userEmail.trim()) newErrors.userEmail = "E-Mail ist erforderlich";
    if (isEmailExist.length >= 1) {
      newErrors.userEmail = "Email already exists.";
    } else if (!emailRegex.test(user.userEmail)) {
      newErrors.userEmail = "Enter a valid email address.";
    }
    if (userModulePermissions.length < 1)
      newErrors.userModulePermissions =
        "Atleast one user module permissions is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const saveUserDetails = async () => {
    if (validateForm()) {
      var newUpdatedUserData = await mapUserData();
      try {
        const response = await axiosInstance.post(
          "/api/UserManagement/updateUserModulePermissions",
          newUpdatedUserData
        );
        if (response?.isSuccess) {
          handleClosePopUp();
          getUserList();
        }
      } catch (error) {
        console.error("Error creating order:", error);
      }
    }
  };

  const handleClosePopUp = (e) => {
    closeEditUserPopup();
    closePopUp();
  };

  if (openPopUp !== true) return null;

  return (
    <div
      id="ModelContainer"
      className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-[10000] overflow-visible"
    >
      <div className="flex justify-center items-center py-10">
        <div className="relative bg-white w-5/6 md:w-[730px] mx-auto rounded-[30px] p-20 pt-14 shadow-[0_0_7px_rgba(92,92,92,0.35)] drop-shadow-[0_0_4px_rgba(178,178,178,0.2)">
          <a
            className="absolute right-8 top-8 text-4xl text-gray-500 pointer"
            id="closePopup"
            onClick={handleClosePopUp}
          >
            <AiOutlineClose />
          </a>
          <div className="w-full">
            <p className="font-interBold text-blue-600 py-7 text-3xl">
              Details bearbeiten
            </p>
            <div>
              {/* First Name */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  First Name
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-4 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    placeholder="First Name"
                    value={user.userFirstName}
                    onChange={(e) => {
                      setUser((prevUser) => ({
                        ...prevUser,
                        userFirstName: e.target.value,
                      }));
                      setErrors((prev) => ({ ...prev, userFirstName: "" }));
                    }}
                  />
                  {errors.userFirstName && (
                    <p className="text-red text-sm mt-1">
                      {errors.userFirstName}
                    </p>
                  )}
                </div>
              </div>

              {/* Last Name */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  Last Name
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-3 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    placeholder="Last Name"
                    value={user.userLastName}
                    onChange={(e) => {
                      setUser((prevUser) => ({
                        ...prevUser,
                        userLastName: e.target.value,
                      }));
                      setErrors((prev) => ({ ...prev, userLastName: "" }));
                    }}
                  />
                  {errors.userLastName && (
                    <p className="text-red text-sm mt-1">
                      {errors.userLastName}
                    </p>
                  )}
                </div>
              </div>

              {/* User ID */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  User Id
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-3 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    placeholder="UID"
                    maxLength={3}
                    value={user.uid}
                    onChange={(e) => {
                      const uppercaseLettersOnly = e.target.value
                        .toUpperCase()
                        .replace(/[^A-Z]/g, "");
                      setUser((prevUser) => ({
                        ...prevUser,
                        uid: uppercaseLettersOnly,
                      }));
                      setErrors((prev) => ({ ...prev, uid: "" }));
                    }}
                  />
                  {errors.uid && (
                    <p className="text-red text-sm mt-1">{errors.uid}</p>
                  )}
                </div>
              </div>

              {/* Role */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  Role
                </label>
                <div className="flex-grow">
                  <Select
                    className="position-absolute appearance-none h-12 !border-gray !leading-normal !text-2xl !w-full bg-white !rounded-lg !pl-5 !py-3 !px-2 !text-gray-600 !placeholder:text-gray-600 !hover:border-blue-600 !focus:border-blue-600 !focus:outline-none shadow-none"
                    values={
                      user.roleId
                        ? [{ roleId: user.roleId, roleName: user.roleName }]
                        : []
                    }
                    options={userRoleOptions}
                    onChange={(selectedOption) => {
                      if (selectedOption && selectedOption.length > 0) {
                        const { roleId, roleName } = selectedOption[0];
                        setUser((prevUser) => ({
                          ...prevUser,
                          roleId,
                          roleName,
                        }));
                        setErrors((prev) => ({ ...prev, roleId: "" }));
                      }
                    }}
                    labelField="roleName"
                    valueField="roleName"
                    placeholder="Select a role"
                  />

                  {errors.roleId && (
                    <p className="text-red text-sm mt-1">{errors.roleId}</p>
                  )}
                </div>
              </div>

              {/* User Access */}
              <div className="mb-5">
                <div className="flex items-start">
                  <label className="block pt-1 text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold">
                    Permissions
                  </label>
                  <SelectWithCheckmark
                    className="border-none"
                    user={user}
                    userModulePermissions={userModulePermissions}
                    setUserModulePermissions={setUserModulePermissions}
                  />
                </div>
                <div className="mb-5 flex">
                  <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold">
                    {/* Permissions */}
                  </label>
                  {userModulePermissions.length == 0 &&
                    errors.userModulePermissions && (
                      <p className="text-red text-sm mt-1">
                        {errors.userModulePermissions}
                      </p>
                    )}
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center mb-5">
                <label className="block text-gray-500 w-40 flex-shrink-0 text-2xl font-interBold mb-2">
                  Email
                </label>
                <div className="w-full">
                  <input
                    className="appearance-none border h-12 border-gray leading-relaxed text-2xl w-full bg-white rounded-lg py-3 px-5 text-gray-600 placeholder:text-gray-600 hover:border-blue-600 focus:border-blue-600 focus:outline-none shadow-none"
                    type="text"
                    value={user.userEmail}
                    onChange={(e) => {
                      setUser((prevUser) => ({
                        ...prevUser,
                        userEmail: e.target.value,
                      }));
                      setErrors((prev) => ({ ...prev, userEmail: "" }));
                    }}
                  />
                  {errors.userEmail && (
                    <p className="text-red text-sm mt-1">{errors.userEmail}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-5 flex items-center justify-end gap-5">
              <button
                className="px-5 py-2 border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
                onClick={handleClosePopUp}
              >
                Abbrechen
              </button>
              <button
                className="bg-blue uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in leading-relaxed"
                type="button"
                onClick={saveUserDetails}
              >
                Speichern
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDetailPopup;
